import { createElement } from "@wordpress/element";

/**
 * WordPress dependencies
 */
import { __, _x } from '@wordpress/i18n';
import { Button, Placeholder, ExternalLink } from '@wordpress/components';
import { BlockIcon } from '@wordpress/block-editor';

var EmbedPlaceholder = function EmbedPlaceholder(props) {
  var icon = props.icon,
      label = props.label,
      value = props.value,
      onSubmit = props.onSubmit,
      onChange = props.onChange,
      cannotEmbed = props.cannotEmbed,
      fallback = props.fallback,
      tryAgain = props.tryAgain;
  return createElement(Placeholder, {
    icon: createElement(BlockIcon, {
      icon: icon,
      showColors: true
    }),
    label: label,
    className: "wp-block-embed",
    instructions: __('Paste a link to the content you want to display on your site.')
  }, createElement("form", {
    onSubmit: onSubmit
  }, createElement("input", {
    type: "url",
    value: value || '',
    className: "components-placeholder__input",
    "aria-label": label,
    placeholder: __('Enter URL to embed here…'),
    onChange: onChange
  }), createElement(Button, {
    isLarge: true,
    type: "submit"
  }, _x('Embed', 'button label')), cannotEmbed && createElement("p", {
    className: "components-placeholder__error"
  }, __('Sorry, this content could not be embedded.'), createElement("br", null), createElement(Button, {
    isLarge: true,
    onClick: tryAgain
  }, _x('Try again', 'button label')), " ", createElement(Button, {
    isLarge: true,
    onClick: fallback
  }, _x('Convert to link', 'button label')))), createElement("div", {
    className: "components-placeholder__learn-more"
  }, createElement(ExternalLink, {
    href: __('https://wordpress.org/support/article/embeds/')
  }, __('Learn more about embeds'))));
};

export default EmbedPlaceholder;
//# sourceMappingURL=embed-placeholder.js.map